<template>
  <tr class="line-item">
    <td class="cart-item-image hidden-xs">
      <a :href="lineItem.product_url">
        <img
          :src="lineItem.variant.image_url"
          :alt="lineItem.variant.name"
          width="100"
          height="100"
        />
      </a>
    </td>
    <td class="cart-item-description">
      <a :href="lineItem.product_url">
        {{ lineItem.variant.name }} {{ lineItem.variant.options_text }}
      </a>
    </td>
    <td class="cart-item-price hidden-xs">
      {{ lineItem.display_price }}
    </td>
    <td class="cart-item-quantity">
      <input
        min="1"
        class="form-control line_item_quantity"
        size="5"
        type="number"
        aria-label="Quantity"
        :value="quantity"
        :disabled="disabled"
        @change="onChange"
      />
    </td>
    <td class="cart-item-total">
      {{ lineItem.display_amount }}
    </td>
    <td class="cart-item-delete">
      <a @click.prevent="remove">
        <span class="glyphicon glyphicon-minus-sign" />
      </a>
    </td>
  </tr>
</template>

<script>
  export default {
    props: {
      lineItem: {
        type: Object,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        localLineItem: this.lineItem
      }
    },
    computed: {
      quantity() {
        return this.lineItem.quantity
      },
    },
    methods: {
      remove() {
        this.localLineItem.quantity = 0
        this.$emit("change", this.localLineItem)
      },
      onChange(event) {
        this.localLineItem.quantity = parseInt(event.target.value, 10)
        this.$emit("change", this.localLineItem)
      },
    },
  }
</script>

<style lang="scss">
  @import "../../../styles/globals/variables";

  .line-item {
    height: 63px;

    @media screen and (min-width: $screen-sm) {
      height: 117px;
    }
  }

  .cart-item-description a {
    font-weight: 400;
    color: $dark-blue-gray;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  .cart-item-quantity {
    min-width: 80px;
  }

  .cart-item-image {
    width: 100px;
    height: 100px;
  }

  .glyphicon-minus-sign {
    width: 22px;
    color: #d9534e;
    margin-top: 7px;

    &:hover {
      cursor: pointer;
    }
  }
</style>
